<template>
    <div v-if="preloader">
        <template>
            <v-dialog v-model="preloader" hide-overlay persistent width="300">
                 <BubbleLoader />
            </v-dialog>
        </template>
    </div>
    <div v-else>
      <v-card
        v-if="!isMobile"
        class="background ml-1 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
        style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 100%;
        padding-top: 16px;
        "
        >
        <v-card-title class="pl-0 ml-0">
           <p
              class="breadcrumb-text-unselected underline-on-hover cursor"
              @click="$router.push('/campaign')"
              >
              Campaigns
           </p>
           <v-icon
              class="breadcrumb-arrow-unselected"
              style="margin-top: 6px !important"
              >mdi-chevron-right</v-icon
              >
           <p class="breadcrumb-text" style="margin-top: 2px">Interviewee List </p>
           <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important"
              >mdi-chevron-down</v-icon
              >
        </v-card-title>
        <UserNavMenu/>
     </v-card>
     <v-card
        v-else
        class="background ml-1 mr-6 mt-0 mb-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center mobile-header"
        >
        <div class="d-flex align-center">
            <v-btn icon class="mr-1" @click="$store.commit('SET_MOBILE_NAV_DRAWER_OPEN', true)">
                <v-icon>mdi-menu</v-icon>
            </v-btn>
            <v-card-title class="pl-0 ml-0 mobile-header--title">Interviewee List</v-card-title>
        </div>
        <UserNavMenu/>
     </v-card>
     <div fluid :class="['px-4', !isMobile && 'pad']">
           <v-row v-if="!isMobile" justify="space-between" align="center" class="ma-0 mt-4 mb-2 pa-0">
            <v-col cols="4" sm="4" md="4" class="ma-0 pa-0">
                <div class="text-h6">Interviewee List</div>
            </v-col>

            <v-col cols="8" sm="8" class="d-flex flex-row justify-end ma-0 pa-0">
                <v-card width="350px" class="elevation-0 transparent">
                    <v-text-field solo label="Search here..." hide-details prepend-inner-icon="mdi-magnify"
                        v-model="search" class="search-bar border-button rounded-pill mx-3" dense clearable
                        @input="handleSearchInput">

                    </v-text-field>
                </v-card>
                <v-btn depressed outlined rounded :loading="loaderForDownloadInterviewee" @click="downloadInterviewee"
                    class="btn outline-btn elevation-0 mx-3"><v-icon>mdi-import mdi-rotate-90</v-icon></v-btn>
                <v-btn @click="filterDialog = true"
                    class="btn outline-btn elevation-0 pl-4 pr-6 d-flex flex-row justify-center align-center">
                    <span class="icon"><v-icon>mdi-tune</v-icon></span> <!-- Add your icon here -->
                    <span v-if="filterCount > 0">FILTER ({{ filterCount }})</span>
                    <span v-else>Filter</span>
                </v-btn>


            </v-col>
        </v-row>
        <v-row v-else align="center" class="ma-0 mt-4 mb-2 pa-0">
            <v-col cols="12" class="d-flex flex-row align-center ma-0 pa-0 mobile-toolbar">
                <v-text-field solo label="Search here..." hide-details prepend-inner-icon="mdi-magnify"
                    v-model="search" class="search-bar border-button rounded-pill mr-2 mobile-search-field" dense clearable
                    @input="handleSearchInput">
                </v-text-field>
                <v-btn depressed outlined rounded :loading="loaderForDownloadInterviewee" @click="downloadInterviewee"
                    class="btn outline-btn elevation-0 ml-auto mr-1"><v-icon>mdi-import mdi-rotate-90</v-icon></v-btn>
            </v-col>
        </v-row>

        <v-card v-if="!isMobile" class="mt-6">
        <v-overlay :value="loadingTable" absolute color="transparent" :opacity="0">
            <BubbleLoader />
        </v-overlay>
        <v-data-table :headers="headers" :items="intevieweeList" :loading="loadingTable" class="elevation-1"
        :page.sync="intervieweeListcurrentPage"
         :server-items-length="intervieweeListTotalUser"
        hide-default-footer ref="myTable" :class="isScrollable ? 'frozen-columns-table' : ''">
            <template v-slot:loading>
                <BubbleLoader />
            </template>
            <template v-slot:header.interviewDateTime>
                <v-row class="custom-header">
                    <v-col class="header-cell">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span class="single-line-ellipsis" v-bind="attrs" v-on="on">
                                    Interview Date & Time
                                </span>
                            </template>
                            <span>Interview Date & Time</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:header.interviewAllocation>
                <v-row class="custom-header">
                    <v-col class="header-cell">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span class="single-line-ellipsis" v-bind="attrs" v-on="on">
                                    Interview Allocation
                                </span>
                            </template>
                            <span>Interview Allocation</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:header.interviewRound>
                <v-row class="custom-header">
                    <v-col class="header-cell">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span class="single-line-ellipsis" v-bind="attrs" v-on="on">
                                    Interview Round
                                </span>
                            </template>
                            <span>Interview Round</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.name="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span class="cursor single-line-ellipsis" v-bind="attrs" v-on="on"
                            >{{ item.name }}</span>
                    </template>
                    <span> {{ item.name }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.emailId="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span class="cursor single-line-ellipsis" v-bind="attrs" v-on="on"
                            @click="copyEmailId(item.emailId)">{{ item.emailId }}</span>
                    </template>
                    <span> {{ item.emailId }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.preferredJobRole="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span class="cursor single-line-ellipsis" v-bind="attrs" v-on="on"
                            >{{ item.preferredJobRole }}</span>
                    </template>
                    <span> {{ item.preferredJobRole }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.subject="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span class="cursor single-line-ellipsis" v-bind="attrs" v-on="on"
                            >{{ item.subject.join(', ') }}</span>
                    </template>
                    <span> {{ item.subject.join(', ') }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.interviewAllocation="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span class="single-line-ellipsis" v-bind="attrs" v-on="on">{{ item.interviewAllocation
                        }}</span>
                    </template>
                    <span> {{ item.interviewAllocation }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.status`]="{ item }">
                <v-chip :class="statusChipColorMap.get(item?.status?.toLowerCase())">
                    {{ item.status == 'ACCEPTED' ? 'Scheduled' : item.status == 'INPROGRESS' ? 'Ongoing' :  capitalizeFirstLetter(item.status) }}
                </v-chip>
            </template>
            <template v-slot:[`item.interviewDateTime`]="{ item }">
                <span>{{ getInterviewTime(item.interviewSlotDetails) }}</span>
            </template>
            <template v-slot:item.actions="{ item, index }">
                <div class="d-flex justify-center">
                    <v-menu left bottom offset-x offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <div class="action-btn-wrapper">
                                <v-btn class="content-black-badge" icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                                <span v-if="item.status === 'INVITED' && item?.showNotificationBadge" class="notification-dot dot-position-1"></span>
                            </div>
                        </template>
                        <v-list>
                            <v-list-item v-if="item.status == 'INVITED'" 
                                @click="confirmOrDelegateInterview(item, 'confirm')" :disabled="hourThreshold(item.interviewSlotDetails)">
                                <div class="action-btn-wrapper">
                                    <span> Confirm Availablity</span>
                                    <span v-if="item.status === 'INVITED' && item?.showNotificationBadge" class="notification-dot dot-position-2"></span>
                                </div>
                               
                            </v-list-item>
                            <v-list-item  v-if="$featureFlags.isEnabled('delegate_interview') && !['delegated', 'completed', 'inprogress'].includes(item.status.toLowerCase()) && item.delegatedBy == ''"
                                :disabled="hourThreshold(item.interviewSlotDetails)"
                                @click="confirmOrDelegateInterview(item, 'delegate')">
                                <v-list-item-title>Delegate</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="openInterviewerConsentDialog(item)" v-if="!['delegated', 'declined'].includes(item.status.toLowerCase())" :disabled="!canGiveFeedback(item)">
                                <v-list-item-title>{{ item.status.toLowerCase() == 'inprogress' ? 'Resume Feedback': item.status.toLowerCase() == 'completed' ? 'View Feedback' :  'Add Feedback'}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="showUser(item.userId)">
                                <v-list-item-title>View Candidate</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="testReportRedriction(item)" :disabled="item.currentTestRoundIndex == 0 ">
                                    <v-list-item-title>Test Report</v-list-item-title>
                            </v-list-item>
                                <v-list-item @click="showInterveiwHistory(item)">
                                    <v-list-item-title >Interview History</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>

            <template v-slot:item.languages="{ item }">
                {{ item.availableLanguages.join(", ") }}
            </template>
            <template v-slot:footer="{ props }">
              <table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update-options="onFooterUpdate"
              />
            </template>
        </v-data-table>
        </v-card>
        <v-card v-else class="mt-6 elevation-0">
            <v-overlay :value="loadingTable" absolute color="transparent" :opacity="0">
                <BubbleLoader />
            </v-overlay>

            <div v-for="(item, index) in intevieweeList" :key="`${item.userId}-${index}`" class="interviewee-card">
                <div class="interviewee-card--header">
                    <span class="interviewee-card--name">{{ item.name }}</span>
                    <div class="d-flex align-center">
                        <v-chip small :class="statusChipColorMap.get(item?.status?.toLowerCase())">
                            {{ item.status == 'ACCEPTED' ? 'Scheduled' : item.status == 'INPROGRESS' ? 'Ongoing' : capitalizeFirstLetter(item.status) }}
                        </v-chip>
                        <v-menu left bottom offset-x offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <div class="action-btn-wrapper">
                                    <v-btn class="content-black-badge" icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                    <span v-if="item.status === 'INVITED' && item?.showNotificationBadge" class="notification-dot dot-position-1"></span>
                                </div>
                            </template>
                            <v-list>
                                <v-list-item v-if="item.status == 'INVITED'"
                                    @click="confirmOrDelegateInterview(item, 'confirm')" :disabled="hourThreshold(item.interviewSlotDetails)">
                                    <div class="action-btn-wrapper">
                                        <span> Confirm Availablity</span>
                                        <span v-if="item.status === 'INVITED' && item?.showNotificationBadge" class="notification-dot dot-position-2"></span>
                                    </div>
                                </v-list-item>
                                <v-list-item v-if="$featureFlags.isEnabled('delegate_interview') && !['delegated', 'completed', 'inprogress'].includes(item.status.toLowerCase()) && item.delegatedBy == ''"
                                    :disabled="hourThreshold(item.interviewSlotDetails)"
                                    @click="confirmOrDelegateInterview(item, 'delegate')">
                                    <v-list-item-title>Delegate</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="openInterviewerConsentDialog(item)" v-if="!['delegated', 'declined'].includes(item.status.toLowerCase())" :disabled="!canGiveFeedback(item)">
                                    <v-list-item-title>{{ item.status.toLowerCase() == 'inprogress' ? 'Resume Feedback': item.status.toLowerCase() == 'completed' ? 'View Feedback' : 'Add Feedback' }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="showUser(item.userId)">
                                    <v-list-item-title>View Candidate</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="testReportRedriction(item)" :disabled="item.currentTestRoundIndex == 0">
                                    <v-list-item-title>Test Report</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>

                <div class="interviewee-card--row">
                    <div class="interviewee-card--col">
                        <div class="interviewee-card--label">Email Id</div>
                        <div class="interviewee-card--value" @click="copyEmailId(item.emailId)">{{ item.emailId }}</div>
                    </div>
                    <div class="interviewee-card--col">
                        <div class="interviewee-card--label">Interview Date & Time</div>
                        <div class="interviewee-card--value">{{ getInterviewTime(item.interviewSlotDetails) }}</div>
                    </div>
                </div>

                <div class="interviewee-card--row">
                    <div class="interviewee-card--col">
                        <div class="interviewee-card--label">Interview Round</div>
                        <div class="interviewee-card--value">{{ item.interviewRound }}</div>
                    </div>
                    <div class="interviewee-card--col">
                        <div class="interviewee-card--label">Subject</div>
                        <div class="interviewee-card--value">{{ item.subject.join(', ') }}</div>
                    </div>
                </div>

                <div class="interviewee-card--row">
                    <div class="interviewee-card--col interviewee-card--col-full">
                        <div class="interviewee-card--label">Preferred Job Role</div>
                        <div class="interviewee-card--value">{{ item.preferredJobRole }}</div>
                    </div>
                </div>
            </div>

            <div v-if="!loadingTable && intevieweeList.length === 0" class="text-center grey--text py-8">
                No records found
            </div>

            <div v-if="loadingMoreInterviewees" class="text-center py-4">
                <v-progress-circular indeterminate color="primary" size="24" width="2" />
            </div>
        </v-card>

     </div>
        <v-snackbar v-model="emailSnackbar" :timeout="1000">
            Email Id Copied
        </v-snackbar>
        <InterviewFeedbackDialog
            v-model="viewFeedbackDialog"
            :personalInfo="feedbackPersonalInfo"
            :interviewDetails="feedbackInterviewDetails"
            :proctoringPic="feedbackProctoringPic"
            :interViewFeedback="latestInterViewFeedback || []"
            :interviewerEmail="currentUser.interviewerEmail"
            :round="feedbackRoundIndex + 1"
        />
        <v-dialog v-model="confirmOrDelegateDialog" class="remove-scrollbar" max-width="700px" persistent
            v-if="confirmOrDelegateDialog && !isMobile">
            <v-card class="px-6 pt-6 pb-0 pos-rel">
                <!-- Title -->
                <p class="text-h6">
                    {{ actionType == 'confirm' ? 'Confirm Availability' : 'Delegate' }}
                </p>

                <div>
                    <!-- Details Box -->
                    <div class="mb-6">
                        <v-row>
                            <v-col cols="6">
                                <div class="mb-3">
                                    <div class="text-caption mb-2 grey--text text--darken-1">Name</div>
                                    <div class="text-sutitle-2 grey--text text--darken-3">{{ currentUser.name }}</div>
                                </div>

                                <div class="mb-3">
                                    <div class="text-caption mb-2 grey--text text--darken-1">Level</div>
                                    <div class="text-sutitle-2 grey--text text--darken-3"> {{ currentUser?.level?.join(',') }}
                                    </div>
                                </div>

                                <div>
                                    <div class="text-caption mb-2 grey--text text--darken-1"> Interview Date & Time
                                    </div>
                                    <div class="text-sutitle-2 grey--text text--darken-3">
                                        {{ getInterviewTime(currentUser.interviewSlotDetails) }} </div>
                                </div>
                            </v-col>

                            <v-col cols="6">
                                <div class="mb-3">
                                    <div class="text-caption mb-2 grey--text text--darken-1">Email Id</div>
                                    <div class="text-sutitle-2 grey--text text--darken-3">
                                        {{ this.currentUser.emailId }}
                                    </div>
                                </div>

                                <div>
                                    <div class="text-caption mb-2 grey--text text--darken-1">Subject</div>
                                    <div class="text-sutitle-2 grey--text text--darken-3">
                                       {{currentUser?.subject?.join(',') }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Availability -->
                    <div v-if="actionType == 'confirm'">
                        <div class="d-flex justify-space-between align-center">
                            <div class="d-flex flex-column">
                                <div class="font-weight-medium">
                                    My Availability <span class="red--text">*</span>
                                </div>
                                <div class="grey--text text--darken-1 caption mb-2">
                                    Confirm availability for this interview
                                </div>
                            </div>

                            <v-radio-group v-model="availabilityRadio" row class="ma-0">
                                <v-radio label="Yes" value="yes"></v-radio>
                                <v-radio label="No" value="no"></v-radio>
                            </v-radio-group>
                        </div>
                        <div
  class="d-flex justify-space-between align-center"
  v-if="$featureFlags.isEnabled('delegate_interview') && availabilityRadio == 'no' && currentUser.delegatedBy == ''"
>
  <div class="d-flex align-center">
    <v-checkbox
      v-model="delegateChecked"
      hide-details
      class="ma-0 mr-2"
    ></v-checkbox>

    <div class="font-weight-medium">
      You may delegate this interview if unavailable
    </div>
  </div>
</div>
                    </div>
                    <v-autocomplete
                        v-if="(availabilityRadio == 'no' && delegateChecked) || actionType == 'delegate'"
                        label="Delegate To*" @change='delegateEmailChanged' v-model="delegatedEmailModelVal"
                        :items="emailsToDelegate" multiple chips @update:search-input="onSearchInputUpdate"
                        @update:menu="onMenuToggle($event)" outlined :loading="loadingInterviewers"
                        @focus="onAutocompleteInteraction" :hide-no-data="loadingInterviewers"
                        :item-text="item => `${item.name} (${item.email})`" item-value="email"
                        :disabled="delegatedEmailModelVal.length > 0"
                        :menu-props="{ disabled: delegatedEmailModelVal.length > 0 }" :search-input.sync="tag" dense>
                        <template v-slot:selection="{ item, index }">
                            <v-chip :key="index" close @click:close="removeTag()"
                                class="ma-2 blue--text email-chip n-overflow-hidden">
                                <template >
                                    {{ item.email }}
                                </template>
                            </v-chip>
                        </template>
                        <template v-slot:item="{ item, attrs, on }">
                            <v-list-item v-bind="attrs" v-on="on" :class="`autocomplete-item-${getItemIndex(item)}`"
                                :data-index="getItemIndex(item)">
                                <template v-slot:default="{ active }">
                                    <v-list-item-action>
                                        <v-checkbox :input-value="active" color="primary"
                                            :disabled="delegatedEmailModelVal.length > 0"></v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.email }} <span v-if="item.name"> ({{ item.name
                                        }})</span></v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                    <p
                        v-if="(availabilityRadio == 'no' && delegateChecked) || actionType == 'delegate'"
                        class="delegate-help-text mt-1 mb-3"
                    >
                        The above list displays only interviewers who are available to take the interview.
                    </p>
                    <div v-if="(availabilityRadio == 'no' && delegateChecked) || actionType == 'delegate'">
                        <p class="text-body-2 mb-2">Comments <span class="red--text">*</span></p>
                        <ckeditor @input="captureCommentInput" :config="editorConfig" class="m-ckeditor"
                            v-model="delegationComment" @ready="onEditorReady">
                        </ckeditor>
                        <p class="delegate-help-text mt-1 mb-5">
                            Please specify the reason for delegation.
                        </p>
                    </div>
                </div>

                <!-- Actions -->
                <div class="d-flex justify-end sticky-bottom">
                    <v-btn class="btn outline-btn elevation-0 mx-2 px-3" rounded depressed
                        @click="closeConfirmOrDelegateDialog">Cancel</v-btn>

                    <v-btn rounded class="btn  primary-btn  elevation-0 mx-2 px-3" @click="onSubmit"
                        :disabled="disableSubmit">
                        {{ actionType == 'confirm' ? 'Submit' : 'Delegate' }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <!-- Mobile-only: Confirm Availability / Delegate -->
        <v-dialog v-model="confirmOrDelegateDialog" width="92%" persistent
            v-else-if="confirmOrDelegateDialog && isMobile">
            <v-card class="mobile-confirm-card">
                <div class="mobile-confirm-header">
                    <v-btn icon @click="closeConfirmOrDelegateDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span class="text-h6">{{ actionType == 'confirm' ? 'Confirm Availability' : 'Delegate' }}</span>
                </div>

                <div class="mobile-confirm-body">
                    <v-row no-gutters class="mb-4">
                        <v-col cols="6" style="min-width: 0; max-width: 50%;">
                            <div class="text-caption mb-1 grey--text text--darken-1">Name</div>
                            <div class="text-subtitle-2 text-break grey--text text--darken-3" style="overflow-wrap: anywhere; word-break: break-word;">{{ currentUser.name }}</div>
                        </v-col>
                        <v-col cols="6" style="min-width: 0; max-width: 50%;">
                            <div class="text-caption mb-1 grey--text text--darken-1">Email Id</div>
                            <div class="text-subtitle-2 text-break grey--text text--darken-3" style="overflow-wrap: anywhere; word-break: break-word;">{{ currentUser.emailId }}</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-4">
                        <v-col cols="6" style="min-width: 0; max-width: 50%;">
                            <div class="text-caption mb-1 grey--text text--darken-1">Level</div>
                            <div class="text-subtitle-2 text-break grey--text text--darken-3" style="overflow-wrap: anywhere; word-break: break-word;">{{ currentUser?.level?.join(',') }}</div>
                        </v-col>
                        <v-col cols="6" style="min-width: 0; max-width: 50%;">
                            <div class="text-caption mb-1 grey--text text--darken-1">Subject</div>
                            <div class="text-subtitle-2 text-break grey--text text--darken-3" style="overflow-wrap: anywhere; word-break: break-word;">{{ currentUser?.subject?.join(',') }}</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-4">
                        <v-col cols="12" style="min-width: 0; max-width: 100%;">
                            <div class="text-caption mb-1 grey--text text--darken-1">Interview Date & Time</div>
                            <div class="text-subtitle-2 text-break grey--text text--darken-3" style="overflow-wrap: anywhere; word-break: break-word;">{{ getInterviewTime(currentUser.interviewSlotDetails) }}</div>
                        </v-col>
                    </v-row>

                    <div v-if="actionType == 'confirm'">
                        <div class="font-weight-medium">
                            My Availability <span class="red--text">*</span>
                        </div>
                        <div class="grey--text text--darken-1 caption mb-2">
                            Confirm availability for this interview
                        </div>
                        <v-radio-group v-model="availabilityRadio" row hide-details class="ma-0 mb-2">
                            <v-radio label="Yes" value="yes"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                        </v-radio-group>

                        <div
                            class="d-flex align-center mt-2"
                            v-if="$featureFlags.isEnabled('delegate_interview') && availabilityRadio == 'no' && currentUser.delegatedBy == ''"
                        >
                            <v-checkbox v-model="delegateChecked" hide-details class="ma-0 mr-2"></v-checkbox>
                            <div class="font-weight-medium">You may delegate this interview if unavailable</div>
                        </div>
                    </div>

                    <v-autocomplete
                        v-if="(availabilityRadio == 'no' && delegateChecked) || actionType == 'delegate'"
                        label="Delegate To*" @change='delegateEmailChanged' v-model="delegatedEmailModelVal"
                        :items="emailsToDelegate" multiple chips @update:search-input="onSearchInputUpdate"
                        @update:menu="onMenuToggle($event)" outlined :loading="loadingInterviewers"
                        @focus="onAutocompleteInteraction" :hide-no-data="loadingInterviewers"
                        :item-text="item => `${item.name} (${item.email})`" item-value="email"
                        :disabled="delegatedEmailModelVal.length > 0"
                        :menu-props="{ disabled: delegatedEmailModelVal.length > 0 }" :search-input.sync="tag" dense>
                        <template v-slot:selection="{ item, index }">
                            <v-chip :key="index" close @click:close="removeTag()"
                                class="ma-2 blue--text email-chip n-overflow-hidden">
                                <template>{{ item.email }}</template>
                            </v-chip>
                        </template>
                        <template v-slot:item="{ item, attrs, on }">
                            <v-list-item v-bind="attrs" v-on="on" :class="`autocomplete-item-${getItemIndex(item)}`"
                                :data-index="getItemIndex(item)">
                                <template v-slot:default="{ active }">
                                    <v-list-item-action>
                                        <v-checkbox :input-value="active" color="primary"
                                            :disabled="delegatedEmailModelVal.length > 0"></v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.email }} <span v-if="item.name"> ({{ item.name
                                        }})</span></v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                    <p
                        v-if="(availabilityRadio == 'no' && delegateChecked) || actionType == 'delegate'"
                        class="delegate-help-text mt-1 mb-3"
                    >
                        The above list displays only interviewers who are available to take the interview.
                    </p>
                    <div v-if="(availabilityRadio == 'no' && delegateChecked) || actionType == 'delegate'">
                        <p class="text-body-2 mb-2">Comments <span class="red--text">*</span></p>
                        <ckeditor @input="captureCommentInput" :config="editorConfig" class="m-ckeditor"
                            v-model="delegationComment" @ready="onEditorReady">
                        </ckeditor>
                        <p class="delegate-help-text mt-1 mb-5">
                            Please specify the reason for delegation.
                        </p>
                    </div>
                </div>

                <div class="mobile-confirm-footer">
                    <v-btn class="btn outline-btn elevation-0 mx-2 px-3" rounded depressed
                        @click="closeConfirmOrDelegateDialog">Cancel</v-btn>
                    <v-btn rounded class="btn primary-btn elevation-0 mx-2 px-3" @click="onSubmit"
                        :disabled="disableSubmit">
                        {{ actionType == 'confirm' ? 'Submit' : 'Delegate' }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delegationSuccess">
            <v-card class="interview-schedule--popup pa-6">
                <div v-if="actionLoader" class="pa-16">
                    <BubbleLoader />
                </div>
                <div v-else class="d-flex align-center flex-column">
                    <img class="cursor" width="96px" height="96px" src="../assets/success.svg" />
                    <p class="interview-popup--text">
                        <span>
                            Interview Delegated Successfully
                        </span>
                    </p>
                    <p><v-btn class="btn primary-btn px-16" @click="refreshIntervieweeList">Ok</v-btn></p>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="acceptRejectSuccess">
            <v-card class="interview-schedule--popup pa-6">
                <div v-if="actionLoader" class="pa-16">
                    <BubbleLoader />
                </div>
                <div v-else class="d-flex align-center flex-column">
                    <img class="cursor" width="96px" height="96px" src="../assets/success.svg" />
                    <p class="interview-popup--text">
                        <span>
                            Response Submitted Successfully
                        </span>
                    </p>
                    <p><v-btn class="btn primary-btn px-16" @click="refreshIntervieweeList">Ok</v-btn></p>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="filterDialog" class="cdz" :max-width="isMobile ? undefined : '570px'"
            :fullscreen="isMobile" style="z-index:1000 !important">
        <v-card :width="isMobile ? '100%' : '700px'" height="100vh" class="filterDialogClass">
        <div class="d-flex justify-space-between pt-6 px-4">
          <div class="pl-0 mb-2 text-body1 font-weight-bold black--text" style="font-size: 20px;">
            Filter
          </div>
                  
          <div class="clear-filter-btn" @click="clearFilter" style="font-size: 14px;">
  CLEAR FILTER
</div>
        </div>
        <v-tabs vertical>   
          <div class="ml-3 mt-4 mr-4 filterLine">
            <v-tab key="status" class="black--text justify-start" active-class="activeTab">
              <span>Status</span>
              <span class="status-count-badge ml-1" v-if="selectedStatusFilter.length > 0">{{ selectedStatusFilter.length }}</span>
            </v-tab>
            <v-tab key="preferredJobRole" class="black--text justify-start" active-class="activeTab">
              <span>Preferred Job Role</span>
              <span class="status-count-badge ml-1" v-if="selectedPreferredJobRoleFilter.length > 0">{{ selectedPreferredJobRoleFilter.length }}</span>
            </v-tab>
            <v-tab key="level" class="black--text justify-start" active-class="activeTab">
              <span>Level</span>
              <span class="status-count-badge ml-1" v-if="selectedLevelFilter.length > 0">{{ selectedLevelFilter.length }}</span>
            </v-tab>
            <v-tab key="interviewRound" class="black--text justify-start" active-class="activeTab">
              <span>Interview Round</span>
              <span class="status-count-badge ml-1" v-if="selectedInterviewRoundFilter.length > 0">{{ selectedInterviewRoundFilter.length }}</span>
            </v-tab>
            <v-tab key="interviewDateAndTime" class="black--text justify-start" active-class="activeTab">
              <span>Interview Date and Time</span>
              <span class="status-count-badge ml-1" v-if="selectedInterviewDateAndTimeFilter">1</span>
            </v-tab>
            
          
          </div>
          <v-tab-item key="status">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-text-field
                  v-model="statusSearch"
                  placeholder="Search Here..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  dense
                  outlined
                  rounded
                  hide-details
                  class="mb-3"
                ></v-text-field>
                <v-chip
                  elevated
                  :class="['ma-1', selectedStatusFilter.length === filteredStatusOptions.length && filteredStatusOptions.length > 0 ? 'active-chip' : '']"
                  @click="toggleAll('selectedStatusFilter', filteredStatusOptions)">
                  All
                </v-chip>
                <v-chip-group v-model="selectedStatusFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(status,index) in filteredStatusOptions"
                  :key="status"
                  :value="status"
                  elevated>
                    {{status}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
         
          <v-tab-item key="preferredJobRole">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-text-field
                  v-model="preferredJobRoleSearch"
                  placeholder="Search Here..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  dense
                  outlined
                  rounded
                  hide-details
                  class="mb-3"
                ></v-text-field>
                <v-chip
                  elevated
                  :class="['ma-1', selectedPreferredJobRoleFilter.length === filteredPreferredJobRoleOptions.length && filteredPreferredJobRoleOptions.length > 0 ? 'active-chip' : '']"
                  @click="toggleAll('selectedPreferredJobRoleFilter', filteredPreferredJobRoleOptions)">
                  All
                </v-chip>
                <v-chip-group v-model="selectedPreferredJobRoleFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(preferredJobRole,index) in filteredPreferredJobRoleOptions"
                  :key="preferredJobRole"
                  :value="preferredJobRole"
                  elevated>
                    {{preferredJobRole}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="level">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-text-field
                  v-model="levelSearch"
                  placeholder="Search Here..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  dense
                  outlined
                  rounded
                  hide-details
                  class="mb-3"
                ></v-text-field>
                <v-chip
                  elevated
                  :class="['ma-1', selectedLevelFilter.length === filteredLevelOptions.length && filteredLevelOptions.length > 0 ? 'active-chip' : '']"
                  @click="toggleAll('selectedLevelFilter', filteredLevelOptions)">
                  All
                </v-chip>
                <v-chip-group v-model="selectedLevelFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(level,index) in filteredLevelOptions"
                  :key="level"
                  :value="level"
                  elevated>
                    {{level}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="interviewRound">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-text-field
                  v-model="interviewRoundSearch"
                  placeholder="Search Here..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  dense
                  outlined
                  rounded
                  hide-details
                  class="mb-3"
                ></v-text-field>
                <v-chip
                  elevated
                  :class="['ma-1', selectedInterviewRoundFilter.length === filteredInterviewRoundOptions.length && filteredInterviewRoundOptions.length > 0 ? 'active-chip' : '']"
                  @click="toggleAll('selectedInterviewRoundFilter', filteredInterviewRoundOptions)">
                  All
                </v-chip>
                <v-chip-group v-model="selectedInterviewRoundFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(interviewRound,index) in filteredInterviewRoundOptions"
                  :key="interviewRound"
                  :value="interviewRound"
                  elevated>
                    {{interviewRound}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          
          
          
          <v-tab-item key="interviewDateAndTime">
            <v-card class="my-container school-filter" flat>
              <v-card-text class="pt-0">
                <v-chip-group v-model="selectedInterviewDateAndTimeFilter" active-class="active-chip" column :multiple="false" @change="onChipSelect">
                  <v-chip v-for="(interviewDateAndTime,index) in interviewDateAndTimeOptions" :key="index" :value="interviewDateAndTime.value" elevated>
                    {{interviewDateAndTime.label}}
                  </v-chip>
                  
                </v-chip-group>
                <div class="d-flex justify-center my-3">
                    <span>Or</span>
                </div>
                <div><strong>Custom Range</strong></div>
                <v-row class="mt-4">
                    <v-col cols="12" md="12">
                      <div class="date-field-wrapper">
                        <v-text-field
                          v-model="customStartDate"
                          type="date"
                          outlined
                          dense
                          :class="{ 'date-empty': !customStartDate }"
                          @focus="startDateFocused = true"
                          @blur="startDateFocused = false"
                          @change="onCustomDateSelect"
                        ></v-text-field>
                        <span v-if="!customStartDate" class="date-inner-label">From</span>
                      </div>
                    </v-col>

                    <v-col cols="12" md="12">
                      <div class="date-field-wrapper">
                        <v-text-field
                          v-model="customEndDate"
                          type="date"
                          outlined
                          dense
                          :class="{ 'date-empty': !customEndDate }"
                          @focus="endDateFocused = true"
                          @blur="endDateFocused = false"
                          @change="onCustomDateSelect"
                        ></v-text-field>
                        <span v-if="!customEndDate" class="date-inner-label">To</span>
                      </div>
                    </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <div class="filterDialogButton">
          <v-card-actions class="px-6 pb-0">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              outlined
              class="btn outline-btn pa-4"
              @click="closeFilter"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              class="btn primary-btn pa-4"
              @click="filterintervieweeList" 
              :loading="filterLoader"
              >Apply</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>                
        </v-dialog>
        <v-dialog v-model="interviewerConsentDialog" max-width="500px" persistent>
            <v-card class="pa-6 d-flex flex-column gap-4">
                <p class="text-h6">Interviewer Declaration</p>
                <div class="d-flex align-center">
                    <v-checkbox v-model="isDeclarationAccepted" color="primary" hide-details class="ma-0 pa-0 mr-3"></v-checkbox>
                    <span class="text-body-2 grey--text text--darken-3">
                        I confirm that I have interviewed the candidate and that the ratings, comments, and recommendations documented in this form reflect my assessment of the candidate's performance and overall suitability for the role.
                    </span>
                </div>
                <div class="d-flex justify-end gap-4">
                    <v-btn rounded outlined depressed class="btn outline-btn elevation-0" @click="closeInterviewerConsentDialog">
                        Cancel
                    </v-btn>
                    <v-btn rounded depressed class="btn primary-btn elevation-0" :disabled="!isDeclarationAccepted" @click="confirmInterviewerConsent">
                        Continue
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <UserProfile :user="viewUser" @close="viewUser = null" />
    </div>

</template>
<script>
import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";
import UserNavMenu from "@/components/UserNavMenu.vue";
import UserProfile from '@/components/UserProfile.vue';
import { debounce } from "lodash";
import UsersController from "@/controllers/UsersController";
import CampaignController from "@/controllers/CampaignController";
import BubbleLoader from '@/components/BubbleLoader.vue';
import { format, startOfToday, startOfYesterday, startOfWeek, startOfMonth, endOfToday, endOfYesterday, endOfWeek, endOfMonth } from 'date-fns';
import InterviewFeedbackDialog from "@/components/InterviewFeedbackDialog.vue";


export default {
    name: 'IntervieweeList',
    mixins: [isTableScrollableMixin],
    components: { UserNavMenu, UserProfile, BubbleLoader, InterviewFeedbackDialog },
    data() {
        return {
            delegatedToName: '',
            intervieweeListcurrentPage: 1,
            debouncedSearch: null,
            actionLoader: false,
            tagDebouncer: null,
            delegationSuccess: false,
            menu: false,
            menuContent: null,
            tag: '',
            observedElements: new Set(),
            emailScrollObserver: null,
            mutationObserver: null,
            loadingInterviewers: false,
            editorConfig: {
                height: 90
            },
            delegatedEmailModelVal: [],
            delegationComment: '',
            emailsToDelegate: [],
            availabilityRadio: '',
            viewUser: null,
            actionType: 'confirm',
            loadingTable: false,
            loadingMoreInterviewees: false,
            debouncedIntervieweeScrollHandler: null,
            preloader: false,
            confirmOrDelegateDialog: false,
            viewUserDialog: false,
            search: '',
            loaderForDownloadInterviewee: false,
            filterDialog: false,
            filterCount: 0,
            interviewerStatus: 0,
            interviewerStatusChipNameMap: new Map([[0, ''], [1, 'invited'], [2, 'inprogress'], [3, 'accepted'], [4, 'completed'], [5, 'delegated'], [6, 'declined'],]),
            countFlag: false,
            activeCount: 0,
            expiredCount: 0,
            scheduledCount: 0,
            intevieweeList: [],
            headers: [
                { text: "Name", value: "name", sortable: false, width: '150px' },
                { text: "Email Id", value: "emailId", cellClass: "text-lowercase", sortable: false },
                { text: "Preferred Job Role", value: "preferredJobRole", sortable: false, width: '170px' },
                { text: "Level", value: "level", sortable: false, width: '170px' },
                { text: "Interview Date & Time", value: "interviewDateTime", sortable: false, width: '190px' },
                { text: "Subject", value: "subject", sortable: false },
                { text: "Interview Allocation", value: "interviewAllocation", sortable: false, },
                { text: "Interview Round", value: "interviewRound", sortable: false },
                { text: "Status", value: "status", align: "center", sortable: false },
                { text: "Action", value: "actions", align: "center", sortable: false }
            ],
            emailSnackbar: false,
            viewFeedbackDialog: false,
            feedbackLoading: false,
            feedbackRoundIndex: 0,
            latestInterViewFeedback: null,
            feedbackPersonalInfo: null,
            feedbackInterviewDetails: null,
            feedbackProctoringPic: null,
            allCount: 0,
            invitedCount: 0,
            inprogressCount: 0,
            upcomingCount: 0,
            completedCount: 0,
            delegatedCount: 0,
            declinedCount: 0,
            statusChipColorMap: new Map([
                ['invited', 'purple-chip'],
                ['completed', 'green-chip'],
                ['delegated', 'orange-chip'],
                ['accepted', 'blue-chip'],
                ['declined', 'red-chip'],
                ['inprogress','magenta-chip']
            ]),
            scrollPending: false,
            lastWatchedIndex: -1,
            pageSize: 10,
            currentPage: 1,
            currentUser: {},
            emailList: [],
            acceptRejectSuccess: false,
            intervieweeListTotalUser: 0,
            pagination: {
                page: 1,
                pageSize: 10
            },
    
        selectedLevelFilter:[],
        selectedStatusFilter: [],
        selectedInterviewRoundFilter:[],
        selectedPreferredJobRoleFilter:[],
        selectedInterviewDateAndTimeFilter: null,
        levelOptions: [],
        statusOptions: [],
        interviewRoundOptions: [],
        preferredJobRoleOptions:[],
        interviewDateAndTimeOptions: [
          { label: 'Today', value: 'today' },
          { label: 'Yesterday', value: 'yesterday' },
          { label: 'This Week', value: 'this_week' },
          { label: 'Last Week', value: 'last_week' },
          { label: 'This Month', value: 'this_month' },
          { label: 'Last Month', value: 'last_month' },
        ],
        filterLoader: false,
        preferredJobRoleSearch: '',
        levelSearch: '',
        interviewRoundSearch: '',
        statusSearch: '',
        menuStart: false,
        menuEnd: false,
        customStartDate: null,
        startDateFocused: false,
        endDateFocused: false,
        customEndDate: null,
        isCustomDate :false,
        delegateChecked:false,
        showTabs: false,
        interviewerConsentDialog: false,
        feedbackConsentItem: null,
        isDeclarationAccepted: false,
        }
    },
    async mounted() {
        this.getIntervieweeMasterFilters();
        this.preloader = true;
        await this.initPaginationFromRoute()
        this.initMutationObserver()
        await this.getIntervieweeList()
        await this.intervieweeStatusCount()
        this.debouncedSearch = debounce(this.performSearch, 300);
        this.preloader = false;
        if (this.isMobile) {
            this.debouncedIntervieweeScrollHandler = debounce(this.handleIntervieweeScroll, 150);
            window.addEventListener('scroll', this.debouncedIntervieweeScrollHandler);
        }
    },
    beforeDestroy() {
        if (this.debouncedIntervieweeScrollHandler) {
            window.removeEventListener('scroll', this.debouncedIntervieweeScrollHandler);
        }
    },
    computed: {
        isMobile() {
            console.log(this.$vuetify.breakpoint.smAndDown)
            return this.$vuetify.breakpoint.smAndDown;
        },
        mobilePagination() {
            const itemsLength = this.intervieweeListTotalUser || 0;
            const itemsPerPage = this.pagination.pageSize || 10;
            const page = this.pagination.page || 1;
            const pageCount = itemsPerPage > 0 ? Math.ceil(itemsLength / itemsPerPage) : 0;
            const pageStart = itemsLength === 0 ? 0 : (page - 1) * itemsPerPage;
            const pageStop = itemsPerPage > 0 ? Math.min(page * itemsPerPage, itemsLength) : itemsLength;
            return { page, itemsLength, pageStart, pageStop, pageCount };
        },
        filteredPreferredJobRoleOptions() {
            if (!this.preferredJobRoleSearch) return this.preferredJobRoleOptions;
            return this.preferredJobRoleOptions.filter(o =>
                o.toLowerCase().includes(this.preferredJobRoleSearch.toLowerCase())
            );
        },
        filteredLevelOptions() {
            if (!this.levelSearch) return this.levelOptions;
            return this.levelOptions.filter(o =>
                o.toLowerCase().includes(this.levelSearch.toLowerCase())
            );
        },
        filteredInterviewRoundOptions() {
            if (!this.interviewRoundSearch) return this.interviewRoundOptions;
            return this.interviewRoundOptions.filter(o =>
                o.toLowerCase().includes(this.interviewRoundSearch.toLowerCase())
            );
        },
        filteredStatusOptions() {
            if (!this.statusSearch) return this.statusOptions;
            return this.statusOptions.filter(o =>
                o.toLowerCase().includes(this.statusSearch.toLowerCase())
            );
        },
        disableSubmit() {
            if (this.actionType == 'confirm') {
                if (this.availabilityRadio == 'yes') {
                    return false

                }else if(this.availabilityRadio == 'no' && this.currentUser.delegatedBy !== ''){
                    return false 
                } else if (this.availabilityRadio == 'no' && this.currentUser.delegatedBy == '') {
                    if (this.delegateChecked == false) {
                        return false
                    } else if (this.delegateChecked == true) {
                        if (this.delegatedEmailModelVal.length > 0 && this.delegationComment !== '') {
                            return false
                        } else {
                            return true
                        }
                    }
                } else if (this.availabilityRadio == '') {
                    return true
                }
            } else if (this.actionType == 'delegate') {
                if (this.delegatedEmailModelVal.length > 0 && this.delegationComment !== '') {
                    return false
                } else {
                    return true
                }
            }
        },
    },
    methods: {
        normalizeSelectedStatusFilter() {
            const statusList = Array.isArray(this.selectedStatusFilter)
                ? this.selectedStatusFilter
                : typeof this.selectedStatusFilter === 'string' && this.selectedStatusFilter.length > 0
                    ? this.selectedStatusFilter.split(',')
                    : [];

            return statusList
                .map(status => status?.trim())
                .filter(Boolean)
                .map(status => status === 'Scheduled' ? 'Accepted' : status);
        },
        onChipSelect() {
            this.customStartDate = null
            this.customEndDate = null
        },
        onCustomDateSelect() {
            this.selectedInterviewDateAndTimeFilter = null
        },
        toggleAll(filterKey, options) {
            if (this[filterKey].length === options.length) {
                this[filterKey] = [];
            } else {
                this[filterKey] = [...options];
            }
        },
        async getIntervieweeMasterFilters() {
         const docId = this.$store.state.userInfo.email;
        try {
            const response = await CampaignController.getMasterFiltersForIntervieweeList(docId);
            this.preferredJobRoleOptions = response.data.preferredJobRole;
            this.interviewRoundOptions = response.data.interviewRound;
            this.levelOptions = response.data.level;
            this.statusOptions = response.data.status.map(status => {
              const value = status === "ACCEPTED" ? "SCHEDULED" : status;

              return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            });
            

          
        } catch (error) {
            return error.response;
        }
        },
        filterintervieweeList(){
            this.filterLoader = true;
            this.getFilterCount();
            
            this.getIntervieweeList();
            this.filterLoader = false;
            this.filterDialog = false;
        },
        closeFilter(){
            this.filterDialog = false;
        },
        clearFilter(){
        this.selectedLevelFilter = [],
        this.selectedStatusFilter =  [],
        this.selectedInterviewRoundFilter = [],
        this.selectedPreferredJobRoleFilter = [],
        this.selectedInterviewDateAndTimeFilter =  null,
        this.customStartDate = null,
        this.customEndDate = null,
        this.getFilterCount();
        this.getIntervieweeList();
        this.filterDialog = false;
        
        },
          getFilterCount(){
        if (!this.isCustomDate) {
          this.getDateRange();
        }
        this.filterCount = [
            this.selectedLevelFilter,
            this.selectedStatusFilter,
            this.selectedInterviewRoundFilter,
            this.selectedPreferredJobRoleFilter,
            this.selectedInterviewDateAndTimeFilter
        ].filter(filter => filter?.length > 0).length;
      },
        addCustomDates() {
        this.isCustomDate = true;
        
        if (this.customStartDate && this.customEndDate) {
          this.sendSelectedIntervieweeFilterRange = {
            start: format(new Date(this.customStartDate), 'yyyy-MM-dd 00:00:00'),
            end: format(new Date(this.customEndDate), 'yyyy-MM-dd 23:59:59')
          };
          this.menu = false;
        }
        },
        handleStartDateChange(date) {
        this.menuStart = false;
        if (this.customEndDate && date > this.customEndDate) {
          this.customEndDate = null;
        }
        },
        getPaginationFromRoute() {
            const page = parseInt(this.$route.query.page, 10)
            const pageSize = parseInt(this.$route.query.pageSize, 10)

            return {
                page: Number.isNaN(page) || page < 1 ? this.pagination.page : page,
                pageSize: Number.isNaN(pageSize) || pageSize < 1 ? this.pagination.pageSize : pageSize
            }
        },
        async setPaginationInRoute(pagination) {
            const nextQuery = {
                ...this.$route.query,
                page: pagination.page,
                pageSize: pagination.pageSize
            }

            if (
                String(this.$route.query.page) === String(pagination.page) &&
                String(this.$route.query.pageSize) === String(pagination.pageSize)
            ) {
                return
            }

            await this.$router.replace({ query: nextQuery })
        },
        async initPaginationFromRoute() {
            const pagination = this.getPaginationFromRoute()
            this.pagination = { ...this.pagination, ...pagination }
            this.intervieweeListcurrentPage = this.pagination.page
            this.pageSize = this.pagination.pageSize
            await this.setPaginationInRoute(this.pagination)
        },
      getHoursLeftFromRange(targetDateTime, startDateTime = new Date()) {
            const now = new Date();
            const target = new Date(targetDateTime);
            const start = new Date(startDateTime);
            
            // Validate dates
            if (isNaN(target.getTime()) || isNaN(start.getTime())) {
                throw new Error('Invalid date/time provided');
            }
            
            const timeLeft = target - now;
            
            // If we're past the target, return 0
            if (timeLeft <= 0) {
                return 0;
            }
            
            // If we're before the start, return total duration in hours
            if (now < start) {
                return (target - start) / (1000 * 60 * 60);
            }
            
            // Convert milliseconds to hours
            const hoursLeft = timeLeft / (1000 * 60 * 60);
            
            return Math.round(hoursLeft * 100) / 100; // rounded to 2 decimal places
        },
        getMinutesLeftFromRange(targetDateTime, startDateTime = new Date()) {
            const now = new Date();
            const target = new Date(targetDateTime);
            const start = new Date(startDateTime);

            if (isNaN(target.getTime()) || isNaN(start.getTime())) {
                throw new Error('Invalid date/time provided');
            }

            const timeLeft = target - now;

            if (timeLeft <= 0) return 0;

            if (now < start) {
                return (target - start) / (1000 * 60); // minutes
            }

            const minutesLeft = timeLeft / (1000 * 60);
            return Math.round(minutesLeft * 100) / 100;
        },
        async intervieweeStatusCount(){
            let queryString = '?'
            let payload = {}

            if (this.$store.state.userInfo.email) {
                payload['interviewerEmail'] =  this.$store.state.userInfo.email;
            }

            if (this.search !== '') {
                payload['search'] = this.search;
            }
             queryString += Object.keys(payload).map(key => `${key}=${payload[key]}`).join('&');
            try {
                const res = await CampaignController.intervieweeStatusCount(queryString)
                if(res.status == 200){
                let counts = res.data.counts
                this.allCount = res.data.total || 0
                this.invitedCount = counts.INVITED || 0;
                this.inprogressCount = counts.INPROGRESS || 0
                this.upcomingCount =  counts?.ACCEPTED || 0;
                this.completedCount = counts?.COMPLETED || 0;
                this.delegatedCount = counts?.DELEGATED || 0;
                this.declinedCount = counts?.DECLINED || 0
                }
            }catch(error){
                console.log(error)
            }
        },
        async refreshIntervieweeList() {
            this.acceptRejectSuccess = false
            this.delegationSuccess = false
            await this.getIntervieweeList()
            await this.intervieweeStatusCount()

        },
        capitalizeFirstLetter(str) {
        if (!str) return str;
        // Convert entire string to lowercase first, then capitalize first letter
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        },
        async onFooterUpdate(newOptions) {
            this.pagination = {
                ...this.pagination,
                page: newOptions.page,
                pageSize: newOptions.itemsPerPage
            };
            this.intervieweeListcurrentPage = this.pagination.page;
            this.pageSize = this.pagination.pageSize;
            await this.$nextTick();
            await this.setPaginationInRoute(this.pagination);
            await this.getIntervieweeList();
        },
        handleSearchInput() {
            this.debouncedSearch();
        },
        async performSearch() {
            this.page = 1
            this.currentPage = 1
            this.pagination = {
                ...this.pagination,
                page: 1
            }
            this.intervieweeListcurrentPage = this.pagination.page
            await this.setPaginationInRoute(this.pagination)
            await this.getIntervieweeList()
            await this.intervieweeStatusCount()
        },
        handlePaste(event) {
            event.preventDefault();
            const pastedText = event.clipboardData.getData('text');
            const email = pastedText.split(',').map(email => email.trim())[0];
            this.tag = email.trim();
            this.addTag(this.tag);
        },
        async addTag(mailId) {
            let IsEmailValid = await this.isValidEmailDomain(mailId)
            if (IsEmailValid) {
                if (this.tag !== '') {
                    this.delegatedEmailModelVal.push(mailId)
                }
                this.tag = ''
                this.delegatedEmailModelVal = [...new Set(this.delegatedEmailModelVal)]
                this.isInvalidEmailDomain = false;
                // await this.checkSlotsForEmails()
            }
            else {
                this.isInvalidEmailDomain = true;
                // await this.checkSlotsForEmails()
            }

        },
        async checkSlotsForEmails() {
            let slot = this.currentUser?.interviewSlotDetails[this.currentUser.interviewSlotDetails.length - 1]
            let currentSlotId = slot?.slotDate
            let currentTimeSlotIndex = slot?.timeSlotDetails?.index
            if (this.delegatedEmailModelVal.length > 0 && currentSlotId && currentTimeSlotIndex.toString()) {
                this.emailList = await Promise.all(this.delegatedEmailModelVal.map(async email => await this.checkSlotCall(email)))
            }
        },
        async isValidEmailDomain(email) {
            if (email == "") return true;
            const { exists } = await UsersController.validateMDMEmail(email);
            return !!exists;
        },
        openInterviewerConsentDialog(item) {
            this.feedbackConsentItem = item;
            if (['inprogress', 'completed'].includes(item.status.toLowerCase())) {
                this.confirmInterviewerConsent();
                return;
            }
            this.isDeclarationAccepted = false;
            this.interviewerConsentDialog = true;
        },
        closeInterviewerConsentDialog() {
            this.interviewerConsentDialog = false;
            this.feedbackConsentItem = null;
            this.isDeclarationAccepted = false;
        },
        confirmInterviewerConsent() {
            const item = this.feedbackConsentItem;
            this.closeInterviewerConsentDialog();
            this.addInterviewFeedbackForm(item);
        },
        addInterviewFeedbackForm(item) {
            if (item?.status?.toLowerCase() === 'completed') {
                this.openInterviewFeedbackDialog(item)
                return
            }
            if (!item.interviewSlotDetails) {
                alert('slot not available')
                return
            }
            let slot = item?.interviewSlotDetails[item.interviewSlotDetails.length - 1]
            let adminUser =  item.interviewerEmail
            let slotId = slot?.slotDate
            let timeSlotId = slot?.timeSlotDetails?.index
            let round = slot?.round
            let path = `/interviewFeedback?userId=${item.userId}&intervieweremail=${adminUser}&slotId=${slotId}&timeSlotId=${timeSlotId}&campaignId=${item.campaignId}&round=${round}&isInProgress=${item.status == 'INPROGRESS'}&redirectedFrom=interviewee-list`
            if (this.isMobile) {
                this.$router.push(path)
            } else {
                window.open(this.$router.resolve({ path }).href, '_blank')
            }
        },
        async openInterviewFeedbackDialog(item) {
            this.currentUser = item
            try {
                this.feedbackLoading = true
                const response = await CampaignController.getInterviewReport(item.userId, item.campaignId)
                const result = response?.data?.result || {}
                const interViewFeedback = result?.interViewFeedback || []
                this.feedbackPersonalInfo = result?.personalInfo || null
                this.feedbackInterviewDetails = result?.interviewDetails || null
                this.feedbackProctoringPic = result?.proctoringPic || null
                this.latestInterViewFeedback = interViewFeedback
                // Default to the latest round for this interviewer
                const rounds = [...new Set(interViewFeedback.map(({ round }) => Number(round)))].filter(Boolean)
                this.feedbackRoundIndex = rounds.length ? Math.max(...rounds) - 1 : 0
                // InterviewFeedbackDialog does the round/interviewer processing internally
                this.viewFeedbackDialog = true
            } catch (error) {
                console.error(error)
            } finally {
                this.feedbackLoading = false
            }
        },
       async resetInterviewNotificationBadge() {
            try{
               let  payload = {
                    userId :this.currentUser.userId,
                    badgeName:'showNotificationBadge'
                }
                const res = await CampaignController.resetInterviewNotificationBadge(payload)
                if(res.flag){
                    this.currentUser.showNotificationBadge = false
                }
                
            }catch(error){
                console.log(error)
            }
        },
        getInterviewTime(slotDetails) {
            // If slotDetails is missing or empty
            if (!Array.isArray(slotDetails) || slotDetails.length === 0) {
                return ''
            }

            let curSlot = slotDetails[slotDetails.length - 1]

            // Safe access checks
            const slotDate = curSlot?.slotDate
            const slotStart = curSlot?.timeSlotDetails?.slotStart

            if (!slotDate || !slotStart) {
                return ''
            }

            // Parse date safely
            const dateParts = slotDate.split('-')
            if (dateParts.length !== 3) {
                return ''
            }

            const [year, month, day] = dateParts
            const formattedDate = `${day}/${month}/${year}`

            // Parse time safely
            const timeParts = slotStart.split(':')
            if (timeParts.length < 2) {
                return ''
            }

            let hour = parseInt(timeParts[0], 10)
            let minute = timeParts[1]

            if (isNaN(hour)) {
                return ''
            }

            const ampm = hour >= 12 ? 'pm' : 'am'
            hour = hour % 12 || 12

            const formattedTime = `${hour}:${minute} ${ampm}`

            return `${formattedDate}, ${formattedTime}`
        },
        hourThreshold(slotDetails) {
            if (!Array.isArray(slotDetails) || slotDetails.length === 0) {
                return false
            }

            const curSlot = slotDetails[slotDetails.length - 1]
            const slotDate = curSlot?.slotDate
            const slotEnd = curSlot?.timeSlotDetails?.slotEnd

            if (!slotDate || !slotEnd) {
                return false
            }

            const slotDateTime = `${slotDate} ${slotEnd}`

            try {
                return this.getMinutesLeftFromRange(slotDateTime) <= 15
            } catch (error) {
                return false
            }
        },

        async getUserInfo(currentUserId, show = false) {
            try {
                const res = await UsersController.getUserInfo(currentUserId)
                if (res.flag) {
                    if (show) {
                        this.viewUser = res.user
                    }

                }
            } catch (error) {
                console.error(error)
            }
        },
        getDateRange() {
        switch (this.selectedInterviewDateAndTimeFilter) {
          case 'today':
            this.sendSelectedIntervieweeFilterRange = {
              start: format(startOfToday(), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfToday(), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'yesterday':
            this.sendSelectedIntervieweeFilterRange = {
              start: format(startOfYesterday(), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfYesterday(), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'this_week':
            this.sendSelectedIntervieweeFilterRange = {
              start: format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'last_week':
            const lastWeekDate = new Date(new Date().setDate(new Date().getDate() - 7));
            this.sendSelectedIntervieweeFilterRange = {
            start: format(startOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 00:00:00'),
            end: format(endOfWeek(lastWeekDate, { weekStartsOn: 1 }), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'this_month':
            this.sendSelectedIntervieweeFilterRange = {
              start: format(startOfMonth(new Date()), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfMonth(new Date()), 'yyyy-MM-dd 23:59:59')
            };
            break;
          case 'last_month':
            const lastMonthDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
            this.sendSelectedIntervieweeFilterRange = {
              start: format(startOfMonth(lastMonthDate), 'yyyy-MM-dd 00:00:00'),
              end: format(endOfMonth(lastMonthDate), 'yyyy-MM-dd 23:59:59')
            };
            break;
          default:
            this.sendSelectedIntervieweeFilterRange = {};
            break;
        }
      },
        async getIntervieweeList(append = false) {
            try {
                if (!append) {
                    const pagination = this.getPaginationFromRoute()
                    this.pagination = { ...this.pagination, ...pagination }
                }
                this.intervieweeListcurrentPage = this.pagination.page
                this.pageSize = this.pagination.pageSize

                if (this.customStartDate || this.customEndDate) {
                  const startDate = this.customStartDate || this.customEndDate;
                  const endDate = this.customEndDate || this.customStartDate;
                  this.sendSelectedIntervieweeFilterRange = {
                    start: format(new Date(startDate), 'yyyy-MM-dd 00:00:00'),
                    end: format(new Date(endDate), 'yyyy-MM-dd 23:59:59')
                  };
                  
                }
                else{
                    this.getDateRange();
                }
                
                let filterDateRange = {};
                if(this.sendSelectedIntervieweeFilterRange?.end != "" && this.sendSelectedIntervieweeFilterRange?.start != "") {
                    filterDateRange = JSON.stringify(this.sendSelectedIntervieweeFilterRange);
                };

                if (append) {
                    this.loadingMoreInterviewees = true
                } else {
                    this.loadingTable = true
                    this.intevieweeList = []
                }
                let queryString = `?`;
                
                let payload = {
                    // status: this.interviewerStatusChipNameMap.get(this.interviewerStatus),
                    pageNumber: this.pagination.page,
                    pageSize: this.pagination.pageSize,
                    interviewerEmail:  this.$store.state.userInfo.email,
                    level: this.selectedLevelFilter,
                    preferredJobRole: this.selectedPreferredJobRoleFilter,
                    interviewRound:this.selectedInterviewRoundFilter,
                    filterDateRange:filterDateRange,
                    status: this.normalizeSelectedStatusFilter(),
                }
                
                if (this.search && this.search.length > 0) {
                    payload['search'] = this.search
                }

                if (Object.keys.length > 0) {
                    queryString += Object.keys(payload)
                        .map(key => `${key}=${payload[key]}`)
                        .join('&');
                } else {
                    queryString = ''
                }
 
                const res = await CampaignController.getIntervieweeList(queryString)
                if (res.status == 200) {
                    if (append && (!res.data.data || res.data.data.length === 0)) {
                        this.intervieweeListTotalUser = this.intevieweeList.length
                    } else {
                        this.intevieweeList = append ? [...this.intevieweeList, ...res.data.data] : res.data.data
                        this.intervieweeListTotalUser = res.data.totalUser
                    }
                }
            } catch (error) {
                console.log(error)
            } finally {
                if (append) {
                    this.loadingMoreInterviewees = false
                } else {
                    this.loadingTable = false
                }
            }
        },
        async loadMoreInterviewees() {
            if (!this.isMobile || this.loadingTable || this.loadingMoreInterviewees) return
            if (this.intevieweeList.length >= this.intervieweeListTotalUser) return
            this.pagination = { ...this.pagination, page: this.pagination.page + 1 }
            this.intervieweeListcurrentPage = this.pagination.page
            await this.setPaginationInRoute(this.pagination)
            await this.getIntervieweeList(true)
        },
        handleIntervieweeScroll() {
            if (!this.isMobile) return;
            const scrollBottom = window.innerHeight + window.scrollY;
            const documentHeight = document.documentElement.scrollHeight;
            if (scrollBottom >= documentHeight - 200) {
                this.loadMoreInterviewees();
            }
        },
        scrollMenuToTop() {
            if (this.menuContent.length > 0) {
                let element = this.menuContent[0]
                element.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                this.scrollPending = false
            } else {
                this.scrollPending = true
            }
        },
        getItemIndex() {
            return Math.random() * 1000;
        },
        getInterviewEmailSlot(index) {
            return this.emailList[index]?.isSlotAvalable ?? true;
        },
        removeTag() {
            this.delegatedEmailModelVal = []
        },
        onSearchInputUpdate(value) {
            if (value === null) return; // 🔥 IMPORTANT
            this.tag = value;

            // Clear previous timer


            // Don't search if query is empty or too short
            if (!value || value.length < 2) {
                return;
            }

            // Debounce the API call
            this.debouncedTagChange()
        },
        debouncedTagChange() {
            if (this.tagDebouncer == null) {
                this.tagDebouncer = debounce(async function (newVal, oldVal) {
                    if (this.tag == null) {
                        if (this.lastWatchedIndex > -1) {
                            await this.getInterviewerDetails('fetch');
                            this.menu = newVal?.length > 0;
                        }
                    } else {
                        this.resetAutoComplete()
                        await this.getInterviewerDetails('fetch');
                        this.scrollMenuToTop()
                        this.menu = newVal?.length > 0;
                    }
                }, 500)
            }
            this.tagDebouncer()
        },
        async onBlur() {
            this.resetAutoComplete()
            await this.getInterviewerDetails(this.getInterviewersFromcacheOrFetch())
            this.scrollMenuToTop()
        },
        resetAutoComplete() {
            this.currentPage = 1
            this.availableEmails = []
            this.observedElements.clear();
            this.lastWatchedIndex = -1
        },
        async checkSlotCall(email) {
            if (!this.currentUser.interviewSlotDetails) {
                alert('slot not available')
                return
            }
            let slot = this.currentUser?.interviewSlotDetails[this.currentUser?.interviewSlotDetails.length - 1]
            let slotId = slot?.slotDate
            let timeSlotId = slot?.timeSlotDetails?.index
            const res =
                await CampaignController.checkAvalableSlotsForInterviewer(
                    email,
                    slotId,
                    timeSlotId.toString()
                );
            return {
                email,
                isSlotAvalable: res?.data?.flag,
            }
        },
        captureCommentInput() {

        },
        onEditorReady(editor) {
            editor.on("afterCommandExec", function (event) {
                var commandName = event.data.name;
                if (['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName)) {
                    setTimeout(() => {
                        const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
                        wiris_license_overlays.forEach(element => {
                            element.remove();
                        });
                    }, 2000)
                }
            })
        },
        async onAutocompleteInteraction() {
            await this.getInterviewerDetails('fetch');
        },
        initMutationObserver() {
            // Clean up any existing observer
            if (this.mutationObserver) {
                this.mutationObserver.disconnect();
            }


            this.mutationObserver = new MutationObserver((mutations) => {
                this.menuContent = document.querySelectorAll('.v-menu__content.menuable__content.menuable__content__active');
                if (this.menuContent) {
                    this.initIntersectionObserver();
                    this.mutationObserver.disconnect(); // Stop observing once found
                }
            });

            // Start observing the document body for changes
            this.mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        },
        getElementIdentifier(element) {
            // Generate unique ID based on element properties
            return element.className + '_' + element.textContent.slice(0, 20) + '_' + element.offsetTop;
        },
        initIntersectionObserver() {
            // Create the observer
            this.emailScrollObserver = new IntersectionObserver(debounce(async (entries) => {
                let entry = entries[0]
                if (entry.isIntersecting) {
                    const elementIndex = parseInt(entry.target.dataset.index, 10);
                    const elementId = this.getElementIdentifier(entry.target);
                    if (this.observedElements.has(`${elementId}-${elementIndex}`)) {
                        return;
                    }
                    this.observedElements.add(`${elementId}-${elementIndex}`);
                    this.lastWatchedIndex = elementIndex
                    this.currentPage++
                    await this.getInterviewerDetails('fetch')
                }

            }, 0, {
                root: document.querySelector('.v-menu__content.menuable__content.menuable__content__active'), // The dropdown content
                threshold: 0
            }));
        },
        observeLastTenthItem() {
            let attempts = 0;
            const maxAttempts = 10;

            const delay = () => new Promise(res => setTimeout(res, 500 * attempts));

            const tryObserve = async () => {
                const items = document.querySelectorAll('.v-select-list .v-list-item');

                if (items.length === this.emailsToDelegate.length) {
                    if (this.scrollPending) this.scrollMenuToTop();

                    if (this.hasMoreData) { // Only observe if more data exists
                        const idx = items.length - 5;
                        if (idx >= 0) {
                            this.emailScrollObserver?.disconnect();
                            this.emailScrollObserver.observe(items[idx]);
                        }
                    }
                    return;
                }

                if (attempts++ < maxAttempts) {
                    await delay();
                    tryObserve();
                }
            };

            tryObserve();
        },
        delegateEmailChanged() {
            this.addTag(this.delegatedEmailModelVal[0])
            this.delegatedToName = this.emailsToDelegate.find(i => i.email == this.delegatedEmailModelVal[0])?.name 
        },

        async getInterviewerDetails(src = 'cache') {
            try {
                this.loadingInterviewers = true;
                let slot = this.currentUser?.interviewSlotDetails[this.currentUser.interviewSlotDetails.length - 1]
                let currentSlotId = slot?.slotDate
                let currentTimeSlotIndex = slot?.timeSlotDetails?.index
                const queryData = {
                    searchQuery: this.tag || "",
                    page: Number(this.currentPage),
                    src,
                    slotId:currentSlotId,
                    slotIndex:currentTimeSlotIndex,
                    schoolCode: this.currentUser.schoolCode,
                    
                };
                const query = "?" + new URLSearchParams(queryData).toString();

                const response = await UsersController.getInterviewerDetails(query);
                const fetchedEmails = response.interviewerDetails || [];
                // this.watchedElements.push(...fetchedEmails)
                this.hasMoreData = response.hasMore;
                // Ensure selected items are preserved

                const mergedEmails = [
                    ...new Map(
                        [...this.emailsToDelegate, ...fetchedEmails].map(item => [item.email, item])
                    ).values()
                ];
                this.emailsToDelegate = mergedEmails;
                this.loadingInterviewers = false;
                // Observe the new last item
                await this.$nextTick()
                this.observeLastTenthItem();

            } catch (error) {
                console.error(error);
            } finally {
                this.loadingInterviewers = false;
            }
        },
        testReportRedriction(data) {
            let path = `/testreport/${data.campaignId}/${data.userId}`
            if (data?.numberOfRounds) {
                if (data.numberOfRounds.includes('screening') || data.numberOfRounds.includes('mains')) {
                    path = `/testreport/${data.campaignId}/${data.userId}`;
                } else if (data.numberOfRounds.includes('demo')) {
                    path = `/demoreport/${data.campaignId}/${data.userId}`;
                } else if (data.numberOfRounds.includes('interview')) {
                    path = `/interviewReport/${data.campaignId}/${data.userId}`;
                }
            }
            if (this.isMobile) {
                this.$router.push({ path, query: { redirectedFrom: 'interviewee-list' } });
                return;
            }
            const url = this.$router.resolve({ path, query: { redirectedFrom: 'interviewee-list' } }).href;
            window.open(url, '_blank');
        },
        showInterveiwHistory(user) {
            const routeData = this.$router.resolve({
                name: "InterviewHistory",
                path: "/interview-history",
                query: {
                    campaignId: user.campaignId,
                    userId: user.userId,
                    viewType: 'interviewer',
                    redirectedFrom: 'interviewee-list', 
                    interviewerEmail: user.interviewerEmail
                },
            });

            window.open(routeData.href, "_blank");
        },
        closeConfirmOrDelegateDialog() {
            this.confirmOrDelegateDialog = false;
            this.delegateChecked = false
            this.availabilityRadio = ""
            this.actionType = ''
            this.delegatedEmailModelVal = []
            this.emailList = 0
            this.tag = ''
        },
        async onSubmit() {
            if (this.actionType == 'confirm') {
                if (this.delegateChecked == false) {
                    this.availabilityRadio == 'yes' ? await  this.acceptOrRejectbyInterveiwer("ACCEPT") : await this.acceptOrRejectbyInterveiwer("REJECT")
                } else if (this.delegateChecked == true) {
                    await this.deletegeInterviewCall()
                } else if (this.availabilityRadio == 'yes') {
                    await this.acceptOrRejectbyInterveiwer("ACCEPT")
                }
            } else if (this.actionType == 'delegate') {
                await this.deletegeInterviewCall()
            }

        this.closeConfirmOrDelegateDialog()
        },
        async acceptOrRejectbyInterveiwer(status) {
            try {
                let payload = {
                    status: status,
                    uid: this.currentUser.calendarUid,
                    interviewerEmail:  this.currentUser.interviewerEmail
                }
                this.actionLoader = true
                const res = await CampaignController.acceptOrRejectbyInterviewer(payload)
                if (res.status == 200) {
                    this.acceptRejectSuccess = true
                    this.confirmOrDelegateDialog = false
                }
                this.actionLoader = false

            } catch (err) {
                console.log(err)
            }
        },
        isPastOrToday(slotDetails) {
            if (!Array.isArray(slotDetails) || slotDetails.length === 0) {
                return false
            }

            const curSlot = slotDetails[slotDetails.length - 1]
            const dateString = curSlot?.slotDate
            if (!dateString) {
                return false
            }

            const parts = dateString.split('-')
            if (parts.length !== 3) {
                return false
            }

            const [year, month, day] = parts.map(part => parseInt(part, 10))
            if ([year, month, day].some(val => Number.isNaN(val))) {
                return false
            }

            const now = new Date()

            // Normalize both dates to midnight (ignore time)
            const slotDate = new Date(year, month - 1, day)
            slotDate.setHours(0, 0, 0, 0)

            const today = new Date(now)
            today.setHours(0, 0, 0, 0)

            return slotDate <= today
        },
        canGiveFeedback(item) {
            const status = item.status.toLowerCase();
            if (status === 'completed') {
                return true;
            }

            // New flag from item - if backend says feedback isn't enabled, stop here
            if (!item.enableFeedback) {
                return false;
            }

            // Hiring manager already gave a decision for the current round
            const currentInterviewRound = item?.interviewRound.replace('Round', '').trim() || 1;
            const decisionGivenForCurrentRound = item.interviewFinalStatus?.currentRound == currentInterviewRound;
            if (decisionGivenForCurrentRound) {
                return false;
            }

            // Time-based check (was isFeedbackEnabled)
            const slotDetails = item.interviewSlotDetails;
            if (!Array.isArray(slotDetails) || slotDetails.length === 0) {
                return false;
            }

            const curSlot = slotDetails[slotDetails.length - 1];
            const dateString = curSlot?.slotDate;
            const slotStart = curSlot?.timeSlotDetails?.slotStart; // "15:00"

            if (!dateString || !slotStart) {
                return false;
            }

            const parts = dateString.split('-');
            if (parts.length !== 3) {
                return false;
            }

            const [year, month, day] = parts.map(part => parseInt(part, 10));
            if ([year, month, day].some(val => Number.isNaN(val))) {
                return false;
            }

            const [slotHour, slotMinute] = slotStart.split(':').map(Number);
            const slotDateTime = new Date(year, month - 1, day, slotHour, slotMinute, 0, 0);
            const fifteenMinsBefore = new Date(slotDateTime.getTime() - 15 * 60 * 1000);

            return new Date() >= fifteenMinsBefore;
        },
        removeHtmlTags(text) {
          return text.replace(/<[^>]*>/g, '');
        },
        async deletegeInterviewCall() {
            let slot = this.currentUser?.interviewSlotDetails[this.currentUser.interviewSlotDetails.length - 1]
            let slotId = slot?.slotDate
            let slotIndex = `${slot?.timeSlotDetails?.index}`
            try {
                let payload = {
                    slotId,
                    slotIndex,
                    campaignId: this.currentUser.campaignId,
                    userId: this.currentUser.userId,
                    round: this.currentUser.interviewRound.replace('Round', "").trim(),
                    fromInterviewerEmail:  this.currentUser.interviewerEmail, // currentinterviewer
                    toInterviewerEmail: this.delegatedEmailModelVal[0], // degatedToInterviewer  
                    delegatedByEmail: this.$store.state.userInfo.email,
                    comments: this.removeHtmlTags(this.delegationComment),
                    toInterviewerName: this.delegatedToName,
                    fromInterviewerName: this.$store.state.userInfo.name   
                }
                 const res = await CampaignController.delegateInterviewSlot(payload) 

                if (res.status == 200) {
                    this.delegationSuccess = true;
                    this.confirmOrDelegateDialog = false
                }


                this.closeConfirmOrDelegateDialog()
            } catch (err) {
                console.log(err)
            }
        },
        async showUser(userId) {
            await this.getUserInfo(userId, true)
        },
        copyEmailId(emailId) {
            navigator.clipboard
                .writeText(emailId)
                .then(() => {
                    this.emailSnackbar = true;
                })
        },
        async downloadInterviewee() {
            let adminUser = this.$store.state.userInfo
            const getDateInDDMMYYYY = () => {
                const today = new Date(
                    new Intl.DateTimeFormat('en-US', {
                        timeZone: 'Asia/Kolkata',
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                    }).format(new Date()))
                const dd = String(today.getDate()).padStart(2, '0');
                const mm = String(today.getMonth() + 1).padStart(2, '0'); // Month is zero-based
                const yyyy = today.getFullYear();

                return `${dd}${mm}${yyyy}`;
            };
            try {

                if (!this.isCustomDate) {
                    this.getDateRange();
                }
                let filterDateRange = {};
                if(this.sendSelectedIntervieweeFilterRange?.end != "" && this.sendSelectedIntervieweeFilterRange?.start != "") {
                    filterDateRange = JSON.stringify(this.sendSelectedIntervieweeFilterRange);
                };
                let payload = {
                    // status: this.interviewerStatusChipNameMap.get(this.interviewerStatus),
                    pageNumber: this.pagination.page,
                    pageSize: this.pagination.pageSize,
                    interviewerEmail: adminUser.email,
                    level: this.selectedLevelFilter,
                    status: this.selectedStatusFilter,
                    preferredJobRole: this.selectedPreferredJobRoleFilter,
                    interviewRound:this.selectedInterviewRoundFilter,
                    filterDateRange:filterDateRange
                }

                // Add search parameter if it exists and is not empty
                if (this.search && this.search.trim().length > 0) {
                    payload.search = this.search.trim();
                }

                // Build query string only if payload has properties
                let queryString = '';
                const payloadKeys = Object.keys(payload);

                if (payloadKeys.length > 0) {
                    queryString = '?' + payloadKeys
                        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`)
                        .join('&');
                }


                this.loaderForDownloadInterviewee = true;
                const response = await CampaignController.downloadIntervieweeList(queryString);
                if (response.status != 200) {
                    throw new Error('Failed to download CSV');
                }
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
                const link = document.createElement('a');
                link.href = url;
                const date = getDateInDDMMYYYY();
                const fileName = adminUser.name + `_${this.selectedStatusFilter}` + "_list.csv";
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.loaderForDownloadInterviewee = false;
                // return res;

            } catch (error) {
                console.error('Error downloading interviewee list:', error);
                this.loaderForDownloadInterviewee = false;
                // Consider showing user-friendly error message
                throw error; // Re-throw if parent component needs to handle it
            }
        },

        async confirmOrDelegateInterview(item, actionType) {
            this.confirmOrDelegateDialog = true
            this.actionType = actionType
            this.currentUser = item
            if(this.currentUser.status == "INVITED" && this.currentUser.showNotificationBadge){
                await this.resetInterviewNotificationBadge()

            }
            
        }
    },
}
</script>
<style scoped>
.filter-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 10px;
  background-color: #E91E8C;
  color: #000000;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}


.date-field-wrapper {
  position: relative;
}


.date-inner-label {
  position: absolute;
  top: 35%;
  left: 13px;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  pointer-events: none;
}

.date-empty ::v-deep input[type="date"]::-webkit-datetime-edit {
  opacity: 0;
}

.remove-scrollbar .v-dialog {
    overflow-y: auto !important;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
}

.remove-scrollbar .v-dialog::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
}

.pos-rel {
    position: relative !important;
}

.sticky-bottom {
    padding-top: 12px;
    position: sticky;
    height: 70px;
    bottom: 0px;
    z-index: 1000;
    right: 0px;
    background-color: white;
}

.v-dialog {
    scrollbar-width: none;
}

.single-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: auto;
    max-width: 120px;
}
.delegate-help-text {
    font-size: 12px;
    line-height: 18px;
    color: #7a7a7a;
}
.mobile-header {
    min-height: 56px;
}
.mobile-confirm-card {
    display: flex !important;
    flex-direction: column !important;
    height: auto !important;
    max-height: 85vh !important;
    width: 100% !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
    border-radius: 16px !important;
}
.mobile-confirm-header {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    max-width: 100%;
    box-sizing: border-box;
}
.mobile-confirm-body {
    flex: 1 1 auto;
    min-height: 0;
    max-width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 16px;
    box-sizing: border-box;
}
.mobile-confirm-body .col,
.mobile-confirm-body .row {
    min-width: 0;
    max-width: 100%;
}
.mobile-confirm-body .text-subtitle-2,
.mobile-confirm-body .text-caption {
    overflow-wrap: anywhere;
    word-break: break-word;
}
.mobile-confirm-footer {
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    background-color: white;
    max-width: 100%;
    box-sizing: border-box;
}
.mobile-header--title {
    font-size: 1.125rem;
    font-weight: 700;
}
.mobile-search-field {
    flex: 1 1 auto;
    min-width: 0;
}
.interviewee-card {
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 12px;
}
.interviewee-card--header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.interviewee-card--name {
    font-weight: 700;
    font-size: 15px;
}
.interviewee-card--row {
    display: flex;
    margin-top: 10px;
    gap: 12px;
}
.interviewee-card--col {
    flex: 1 1 50%;
    min-width: 0;
}
.interviewee-card--col-full {
    flex: 1 1 100%;
}
.interviewee-card--label {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 2px;
}
.interviewee-card--value {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    max-width: 100%;
    display: block;
    box-sizing: border-box;
}
</style>
